import { useState, useEffect, useRef } from "react";

const SHOW_AFTER_PX = 400;

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  // Tracks whichever element is actually scrolling - usually `window`, but
  // some pages (e.g. the Gallery image column) scroll an inner container
  // instead of the window itself.
  const scrollTargetRef = useRef(null);

  useEffect(() => {
    function topOf(el) {
      return el === window ? window.scrollY : el.scrollTop;
    }

    function handleScroll(e) {
      // Scroll events don't bubble, but a capturing listener on `window`
      // still sees them fire on any descendant scroll container.
      const target = e.target === document ? window : e.target;
      const top = topOf(target);

      if (top > SHOW_AFTER_PX) {
        scrollTargetRef.current = target;
        setVisible(true);
      } else if (target === scrollTargetRef.current) {
        setVisible(false);
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true, capture: true });
    handleScroll({ target: window }); // in case the page loads pre-scrolled
    return () => window.removeEventListener("scroll", handleScroll, { capture: true });
  }, []);

  function scrollToTop() {
    const target = scrollTargetRef.current || window;
    target.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed right-12 bottom-8 z-40 w-12 h-12 flex items-center justify-center rounded-full bg-black/70 hover:bg-red-700 border border-white/10 shadow-lg shadow-black/30 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-none stroke-white stroke-[2.5]" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  );
};

export default ScrollToTopButton;